import React from "react";
import { formatMomentString } from "../dateHelpers";
import YellowBar from "../../components/utils/YellowBar";

export const showWatchedBar = (video, user, videoSurveys = [], translations = {}) => {
	// If the user hasn't watched any videos, bail!
	if (!user.videos) return null;

	// Get the video Id
	const videoId = getVideoIdFromUri(video);

	// Filter out video if it's been watched
	const videos = videoHasBeenWatched(videoId, user);

	// If video has not been returned, bail!
	if (!videos.length) return null;

	// Get the date the video was watched
	const watchedDate = videos[0].date_added;

	// See if we can grab the video survey
	const survey = videoSurveyExists(videoId, videoSurveys);

	// Return the "Watched" component
	return (
		<React.Fragment>
			<YellowBar>
				{translations.sections.training_video_preview_item.watched_label}
				{!!watchedDate && ` (${formatMomentString(watchedDate, "MM/DD/YYYY")})`}
			</YellowBar>
			{!!survey[0] && (
				<a
					className="btn"
					href={survey[0].survey_url}
					target="_blank"
					rel="noopener noreferrer"
				>
					{translations.sections.training_video_preview_item.test_link}
				</a>
			)}
		</React.Fragment>
	);
};

export const getVideoIdFromUri = video => {
	// If there is no uri, this is probably just an ID, so return it
	if (!video.uri) return video;

	const pieces = video.uri.split("/");
	return pieces[pieces.length - 1];
};

export const videoSurveyExists = (videoId, surveys) => {
	return surveys.filter(survey => {
		if (videoId === survey.vimeoID) {
			return true;
		}

		return false;
	});
};

export const videoHasBeenWatched = (videoId, user) => {
	return user.videos.filter(video => {
		if (video.video_vimeo_id === videoId) {
			return true;
		}

		return false;
	});
};



// WEBPACK FOOTER //
// ./src/utils/training/videos.js